module.exports = __webpack_public_path__ + "static/media/reply.e00225d7.svg";